<template>
  <section class="h-full">
    <template v-if="$route.name === 'Share'">
      <router-view class="w-full" />
    </template>

    <div v-if="!showHeader" class="w-full h-full">
      <router-view class="w-full" />
    </div>

    <template v-if="showHeader && $route.name !== 'Share'">
      <Home />
    </template>

    <NotificationModule />

    <LimitReached />

    <TipTapNodeRenderer />
  </section>
</template>

<script>
import NotificationModule from '@/components/shared/NotificationModule'
import LimitReached from '@/components/confirm/LimitReached'
import Home from '@/pages/Home'
import TipTapNodeRenderer from '@/tiptap/utils/TipTapNodeRenderer'

import { routesWithoutHeader } from '@/router/index'
import designConfig from '@/core/design-config'

import { mapMutations, mapState } from 'vuex'
// import { settingsService } from '@/services'

export default {
  name: 'App',

  metaInfo () {
    return {
      meta: [
        { name: 'description', content: 'Organize your life. Centralize your thoughts. Your brain, saved on paper. From note-taking to planning and writing. Whatever you need, Ivy is here to help.' },
        { property: 'og:title', content: 'Hello Ivy' },
        { property: 'og:site_name', content: 'Hello Ivy' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },

  components: { Home, NotificationModule, LimitReached, TipTapNodeRenderer },

  computed: {
    ...mapState({
      settings: state => state.settings.settings
    }),

    showHeader () {
      if (!this.$route.name) return false
      return !routesWithoutHeader.includes(this.$route.name)
    },

    fontSize () {
      return this.settings ? designConfig.fontSizes[this.settings.fontSize] : null
    }
  },

  watch: {
    // fontSize (value) {
    //   const html = document.getElementsByTagName('html')[0]
    //   html.style.fontSize = value
    // },

    settings: {
      handler () {
        this.styles()
      },
      deep: true
    }
  },

  created () {
    this.setInnerWidth(window.innerWidth)

    window.onresize = () => {
      this.setInnerWidth(window.innerWidth)
    }

    this.styles()
  },

  methods: {
    ...mapMutations(['setInnerWidth', 'updateSettings']),

    styles () {
      if (this.settings) {
        if (!Object.keys(designConfig.themes).includes(this.settings.theme)) {
          const design = {
            ...this.settings,
            theme: 'Magenta'
          }

          this.updateSettings(design)
          // settingsService.update(design)
        }

        const html = document.querySelector('html')
        html.style = `
          background-color: ${designConfig.themes[this.settings.theme].sidebarBg};
          font-size: ${designConfig.fontSizes[this.settings.fontSize]};
          line-height: ${designConfig.lineHeights[this.settings.lineHeight]};

          --primary: ${designConfig.themes[this.settings.theme].primary};
          --main-color: ${designConfig.themes[this.settings.theme].mainColor};
          --link-color: ${designConfig.themes[this.settings.theme].linkColor};
          --checkbox: ${designConfig.themes[this.settings.theme].checkbox};
          --app-color: ${designConfig.themes[this.settings.theme].appColor};
          --canvas-color: ${designConfig.themes[this.settings.theme].canvasColor};
          --selection: ${designConfig.themes[this.settings.theme].selectionColor};
          --canvas: ${designConfig.themes[this.settings.theme].canvasBg};
          --sidebar: ${designConfig.themes[this.settings.theme].sidebarBg};
          --hover: ${designConfig.themes[this.settings.theme].hoverColor};
          --book: ${designConfig.themes[this.settings.theme].book};
          --hover-book: ${designConfig.themes[this.settings.theme].bookHover};
          --comment: ${designConfig.themes[this.settings.theme].comment};
          --scrollBarColor: ${designConfig.themes[this.settings.theme].scrollBarColor};
          --scrollBarThumbColor: ${designConfig.themes[this.settings.theme].scrollBarThumbColor};
          --scrollBarThumbHover: ${designConfig.themes[this.settings.theme].scrollBarThumbHover};
          --project: ${designConfig.themes[this.settings.theme].project};
          --projectHover: ${designConfig.themes[this.settings.theme].projectHover};
          --image-shadow: ${designConfig.themes[this.settings.theme].imageShadow};
          --text-selection: ${designConfig.themes[this.settings.theme].textSelection};

          --book-icon: ${designConfig.themes[this.settings.theme].bookIcon};
          --main-font-family: '${designConfig.fontFamilies[this.settings.fontFamily]}';
        `
      }
    }
  }
}
</script>
